import CoreLoader from '@components/CoreLoader'
import { useExpenseWorkflowCookie } from '@hooks'
import CounterpartyDashboard from '@views/counterparty/CounterpartyDashboard'
import {
  isOwnerOrAdministrator,
  paths,
  selectCurrentUserRole,
  useAppSelector,
  useGetReportListWithoutCacheMutation,
  useMerchantQry,
  useUserProfileQry
} from 'mmfintech-backend-api'
import { GlobalContext, isValidArray } from 'mmfintech-commons'
import { useContext, useEffect, useState } from 'react'
import { Redirect, Route, Switch, useHistory } from 'react-router-dom'
import NavigationSwitch from './@elements/NavigationSwitch'
import ExpenseReports from './ExpenseReports'
import ExpenseWorkflow from './ExpenseWorkflow'
import ExpenseWorkflowModal from './ExpenseWorkflowModal'

import './expensesRouter.scss'

const ExpensesRouter = () => {
  const { modalShow } = useContext(GlobalContext)

  const customerRole = useAppSelector(selectCurrentUserRole)

  const [selectedView, setSelectedView] = useState<string>('reports')

  const history = useHistory()

  const { isShown } = useExpenseWorkflowCookie()

  const { profile, profileLoading } = useUserProfileQry()
  const { merchant, merchantLoading } = useMerchantQry()

  const [fetchReportsRequest, { data: reports, isLoading: reportsFetching, isSuccess: reportsLoaded }] =
    useGetReportListWithoutCacheMutation()

  useEffect(() => {
    if (profile?.userId && !isValidArray(profile?.userPermissions)) {
      history.push(paths.dashboard())
    }
  }, [profile, history])

  useEffect(() => {
    if (merchant?.entityType && merchant.entityType !== 'COMPANY') {
      history.push(paths.dashboard())
    }
  }, [merchant, history])

  // biome-ignore lint/correctness/useExhaustiveDependencies: fetchReportsRequest is RTK mutation, only call when merchant/profile changes
  useEffect(() => {
    if (
      merchant?.entityType === 'COMPANY' &&
      isOwnerOrAdministrator(customerRole) &&
      isValidArray(profile?.userPermissions)
    ) {
      fetchReportsRequest({ deleted: false })
    }
  }, [merchant, profile])

  // biome-ignore lint/correctness/useExhaustiveDependencies: modalShow from GlobalContext is not memoized, including it causes infinite re-renders
  useEffect(() => {
    if (!isShown && isValidArray(reports?.content) && isOwnerOrAdministrator(customerRole)) {
      modalShow({
        content: <ExpenseWorkflowModal />,
        options: { closeOnClickOutside: false, hideCloseIcon: true }
      })
    }
  }, [isShown, reports, customerRole])

  return profileLoading || merchantLoading || reportsFetching || isShown === null ? (
    <CoreLoader />
  ) : isOwnerOrAdministrator(customerRole) && reportsLoaded && !isValidArray(reports?.content) ? (
    <ExpenseWorkflow />
  ) : (
    <div className='expenses-router-wrapper'>
      <NavigationSwitch selected={selectedView} setSelected={setSelectedView} />
      <Switch>
        <Route path={paths.expenseManagement.reports()} exact component={ExpenseReports} />
        <Route path={paths.expenseManagement.counterparties()} exact component={CounterpartyDashboard} />
        <Redirect to={paths.expenseManagement.reports()} />
      </Switch>
    </div>
  )
}

export default ExpensesRouter
